import Vue      from 'vue';
import Vuex     from 'vuex';
import config   from './modules/config';
import mq       from './modules/mq';
import data     from './modules/data';
import segments from './modules/segments';



Vue.use(Vuex);



const store = new Vuex.Store({
  modules: {
    banner: {
      namespaced: true,

      modules: {
        config,
        mq,
        data,
        segments,
      },
    },
  },

  actions: {
    onLoadConfig({dispatch}, data) {
      dispatch('banner/mq/onLoadConfig');
    },
  },

  strict: IS_DEVELOP,
});



export default store;


// WEBPACK FOOTER //
// ./src/shared/bc-banner/store/index.js